import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fixed-top bg-dark shadow-sm border-bottom border-body px-2 py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "d-flex align-items-center justify-content-evenly",
  role: "search"
}
const _hoisted_4 = { class: "w-50" }
const _hoisted_5 = ["onKeydown"]
const _hoisted_6 = {
  key: 0,
  class: "record-count"
}
const _hoisted_7 = {
  key: 1,
  class: "dropdown-list rounded-bottom"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "d-flex float-start w-50"
}
const _hoisted_10 = { class: "badge rounded-pill text-bg-light d-flex align-items-center ms-4 me-2 float-end" }
const _hoisted_11 = {
  key: 1,
  class: "w-50"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { app } from "@/guiide/ts/app";
import { AccountSearchResponse } from '@/guiide/ts/response/accountSearchResponse';
import { AccountSearchResponseItem } from '@/guiide/ts/response/accountSearchResponseItem';
import { useStore } from "vuex";

const minCharsForSearch = 3;
const noSelectedItem = -1;

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminBar',
  setup(__props) {

const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Control', 'Shift', 'Delete', 'Backspace', 'Enter', 'Escape', '@', '_', '.', '-', '+'];
const container = ref(null);
const searchText = ref('');
const accountResults = ref<Array<AccountSearchResponseItem>>(new Array<AccountSearchResponseItem>());
const recordCount = ref(' ');
const selectedItemIndex = ref(noSelectedItem);
const selectedAccount = ref<AccountSearchResponseItem | null>(null);

const store = useStore();

let timeout: ReturnType<typeof setTimeout>;

const delayedSearch = async () => {
    if (searchText.value.length < minCharsForSearch) {
        clearAccountSearchResults();
        return;
    }

    recordCount.value = "...";

    const searchResult: AccountSearchResponse = await app.findAccounts(searchText.value);

    accountResults.value = searchResult.items;
    selectedItemIndex.value = accountResults.value.length > 0 ? 0 : noSelectedItem;
    recordCount.value = searchResult.recordCount.toString();
};

const handleChange = () => {
    if (searchText.value.length >= minCharsForSearch) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(delayedSearch, 500);
    } else {
        clearAccountSearchResults();
    }
};

const showSearchResults = computed<boolean>(() => searchText.value.length >= minCharsForSearch && accountResults.value.length > 0);
const showSelectedAccount = computed<boolean>(() => selectedAccount.value != null);

function clearAccountSearchResults() {
    accountResults.value = new Array<AccountSearchResponseItem>();
    recordCount.value = "";
}

function onKeyDown(event: KeyboardEvent) {
    const allowed = allowedKeys.includes(event.key) || /^[a-zA-Z0-9]$/.test(event.key);
    if (!allowed) {
        event.preventDefault();
        return;
    }

    if (event.key == '@' && searchText.value.includes("@")) {
        event.preventDefault();
    }
}

function onAccountSearchKeyDown() {
    const next = selectedItemIndex.value + 1;
    selectedItemIndex.value = next >= accountResults.value.length ? 0 : next;
}

function onAccountSearchKeyUp() {
    const next = selectedItemIndex.value - 1;
    selectedItemIndex.value = next < 0 ? accountResults.value.length - 1 : next;
}

async function onAccountSelect() {
    if (selectedItemIndex.value == noSelectedItem) {
        return;
    }

    selectedAccount.value = accountResults.value[selectedItemIndex.value];

    store.commit("updateImpersonatingId", selectedAccount.value.id);

    onAccountSearchEnd();

    const withinTransactionOngoing = true;
    const forceViewReload = true;
    await app.getRetiree(withinTransactionOngoing, forceViewReload);
}

function onAccountClick(selectedAccountIndex: number) {
    selectedItemIndex.value = selectedAccountIndex;
    onAccountSelect();
}

function onAccountSearchEnd() {
    clearAccountSearchResults();
    searchText.value = "";
}

async function clearSelectedAccount() {
    selectedAccount.value = null;
    store.commit("updateImpersonatingId", null);
    await app.getRetiree();
}

const handleClickOutside = (event) => {
    if (!container.value.contains(event.target)) {
        onAccountSearchEnd();
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            ref_key: "container",
            ref: container,
            class: "input-group float-end"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              maxlength: 14,
              placeholder: "Email",
              class: _normalizeClass(["form-control me-2", { 'rounded-bottom-off': showSearchResults.value }]),
              style: {"border-bottom-right-radius":"0.375rem"},
              type: "text",
              "aria-label": "Email",
              onInput: handleChange,
              onKeydown: [
                onKeyDown,
                _withKeys(_withModifiers(onAccountSearchKeyDown, ["prevent"]), ["down"]),
                _withKeys(_withModifiers(onAccountSearchKeyUp, ["prevent"]), ["up"]),
                _withKeys(_withModifiers(onAccountSelect, ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(onAccountSearchEnd, ["prevent"]), ["escape"])
              ]
            }, null, 42, _hoisted_5), [
              [_vModelText, searchText.value]
            ]),
            (recordCount.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(recordCount.value), 1))
              : _createCommentVNode("", true),
            (showSearchResults.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountResults.value, (account, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      onClick: ($event: any) => (onAccountClick(i)),
                      class: _normalizeClass(i === selectedItemIndex.value ? 'dropdown-item selected' : 'dropdown-item')
                    }, _toDisplayString(account.email), 11, _hoisted_8))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        (showSelectedAccount.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(selectedAccount.value.email) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close btn-sm ms-2",
                    "aria-label": "Close",
                    onClick: clearSelectedAccount
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, " "))
      ])
    ])
  ]))
}
}

})